import { aiWidgetAliases } from 'components/AiAnalytics/shared/aiWidgetActions';
import { hasRenderableWidgetData } from 'components/AiAnalytics/shared/aiWidgetGuards';
import {
  CustomerEffortBreakdownApiResponse,
  CustomerEffortDistributionDto,
} from 'components/AiAnalytics/shared/aiWidgetResponse.types';
import { CustomerEffortDistributionView, CustomerEffortView } from './CustomerEffort.types';

const buckets = [
  { name: 'Low', id: 'low', color: '#168f86' },
  { name: 'Medium', id: 'medium', color: '#f5a623' },
  { name: 'High', id: 'high', color: '#d64545' },
] as const;

const mapDistribution = (
  distribution: CustomerEffortDistributionDto
): CustomerEffortDistributionView | null => {
  const values = new Map(distribution.series.map((point) => [point.name, point.value] as const));
  if (values.size !== buckets.length || buckets.some(({ name }) => !values.has(name))) return null;
  const segments = buckets.map(({ name, id, color }) => ({
    id,
    label: name,
    color,
    value: values.get(name) as number,
  }));
  return {
    segments,
    highEffortPct: distribution.high_effort_pct,
    hasActivity: segments.some((segment) => segment.value > 0),
  };
};

export const mapCustomerEffortResponse = (response: unknown): CustomerEffortView | null => {
  if (!hasRenderableWidgetData(aiWidgetAliases.CUSTOMER_EFFORT, response)) return null;
  const { data } = response as CustomerEffortBreakdownApiResponse;
  const overall = mapDistribution(data.overall);
  if (!overall) return null;
  const touchpoints = data.by_touchpoint.map((touchpoint) => {
    const distribution = mapDistribution(touchpoint);
    return distribution ? { ...distribution, touchpoint: touchpoint.touchpoint } : null;
  });
  if (touchpoints.some((touchpoint) => !touchpoint)) return null;
  return { overall, touchpoints: touchpoints as CustomerEffortView['touchpoints'] };
};
